import { unitsPerPieceFor } from '~/components/ui/bundleQuantity';
import type { UnitCode } from '~/graphql/graphql';
import { round3 } from '~/utils/lengthParser';
import type { BuyListDetailTally, CannedBuyListDetailTally } from './types';

type TallyLine = BuyListDetailTally['bundles'][number];

function lineQuantityAtCount(
  line: TallyLine,
  unit: UnitCode,
  tally: CannedBuyListDetailTally,
  tallyCount: number
): number {
  const bundleCount = (line.bundleCount * tallyCount) / tally.tallyCount;
  const unitsPerPiece = unitsPerPieceFor(line.platformProductsLength, unit);
  if (unitsPerPiece === null) {
    return round3((line.quantity.value * tallyCount) / tally.tallyCount);
  }
  const pieces =
    bundleCount *
    line.platformProductsLength.platformProduct.piecesPerBundle.value;
  return round3(pieces * unitsPerPiece);
}

/** Sums per-line rounded quantities, as the backend does for the saved count. */
export function tallyQuantityAtCount(
  tally: BuyListDetailTally,
  tallyCount: number | null
): BuyListDetailTally['quantity'] {
  if (
    tally.__typename !== 'CannedBuyListTally' ||
    tallyCount === null ||
    tallyCount === tally.tallyCount
  ) {
    return tally.quantity;
  }
  const unit = tally.quantity.unit;
  const total = tally.bundles.reduce(
    (sum, line) => sum + lineQuantityAtCount(line, unit, tally, tallyCount),
    0
  );
  return { ...tally.quantity, value: round3(total) };
}
